import { createClient } from '@sanity/client'
import { createImageUrlBuilder, type SanityImageSource } from '@sanity/image-url'

const defaultDataset = (process.env.SANITY_DATASET as string | undefined) ?? 'production'
const token = process.env.SANITY_API_READ_TOKEN as string | undefined
const studioUrl = (process.env.SANITY_STUDIO_URL as string | undefined) ?? 'https://9b8csvpk.sanity.studio'

function getRuntimeDataset(): string {
  if (typeof window !== 'undefined') {
    const urlDataset = new URLSearchParams(window.location.search).get('dataset')
    if (urlDataset === 'staging' || urlDataset === 'production') return urlDataset
  }
  return defaultDataset
}

export const client = createClient({
  projectId: '9b8csvpk',
  dataset: defaultDataset,
  apiVersion: '2026-05-15',
  useCdn: false,
})

export function getClient() {
  const dataset = getRuntimeDataset()
  const isPreview =
    typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('preview') === 'true'

  return createClient({
    projectId: '9b8csvpk',
    dataset,
    apiVersion: '2026-05-15',
    useCdn: false,
    ...(isPreview
      ? {
          perspective: 'drafts' as const,
          token,
          stega: {
            enabled: true,
            studioUrl: `${studioUrl}/${dataset}`,
          },
        }
      : {}),
  })
}

const { projectId: pid, dataset: ds } = client.config()
export const urlFor = (source: SanityImageSource) =>
  pid && ds ? createImageUrlBuilder({ projectId: pid, dataset: ds }).image(source) : null
